import React from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { useLanguage } from '../context/LanguageContext';
import { LOGO_CROPPED } from '../lib/assets';
import { CONTACT } from '../lib/contactInfo';
import { InstagramIcon } from './icons/InstagramIcon';

const QUICK_LINKS = (t) => [
  { label: t('nav.products'), to: 'products' },
  { label: t('nav.operations'), to: 'operations' },
  { label: t('nav.markets'), to: 'markets' },
];

const EXPORT_INFO_LINKS = (t) => [
  { label: t('footer.shippingTerms'), to: 'logistics' },
  { label: t('footer.qualityAssurance'), to: 'operations' },
  { label: t('footer.certificates'), to: 'certifications' },
];

function FooterLinkList({ title, links }) {
  return (
    <div>
      <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-5">{title}</h4>
      <ul className="space-y-3">
        {links.map(link => (
          <li key={link.to}>
            <ScrollLink
              to={link.to}
              smooth={true}
              duration={500}
              offset={-80}
              className="text-sm text-slate-400 hover:text-white transition-colors cursor-pointer"
            >
              {link.label}
            </ScrollLink>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="bg-brand-green text-white" data-testid="footer-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-1">
            <img
              src={LOGO_CROPPED}
              alt="Dedari Export"
              className="h-14 w-auto mb-6"
            />
            <p className="text-white/60 text-sm leading-relaxed">
              {t('footer.tagline')}
            </p>
          </div>

          <FooterLinkList title={t('footer.quickLinks')} links={QUICK_LINKS(t)} />
          <FooterLinkList title={t('footer.exportInfo')} links={EXPORT_INFO_LINKS(t)} />

          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-white/40 mb-6">
              {t('footer.contactUs')}
            </h4>
            <ul className="space-y-3 text-sm text-white/60">
              <li>
                <a href={`mailto:${CONTACT.email}`} className="hover:text-brand-orange transition-colors" data-testid="footer-email">
                  {CONTACT.email}
                </a>
              </li>
              <li>
                <a href={CONTACT.whatsapp.href} target="_blank" rel="noreferrer" className="hover:text-brand-orange transition-colors" data-testid="footer-whatsapp">
                  WhatsApp: {CONTACT.whatsapp.display}
                </a>
              </li>
              <li>
                <a href={CONTACT.instagram.href} target="_blank" rel="noreferrer" className="hover:text-brand-orange transition-colors flex items-center gap-2" data-testid="footer-instagram">
                  <InstagramIcon className="w-5 h-5" />
                  Instagram: {CONTACT.instagram.handle}
                </a>
              </li>
              <li>
                <a href={CONTACT.threads.href} target="_blank" rel="noreferrer" className="hover:text-brand-orange transition-colors" data-testid="footer-threads">
                  Threads: {CONTACT.threads.handle}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} DEDARI BALI EXPORT. {t('footer.rights')}
          </p>
          <p className="text-xs text-white/30">
            {t('footer.madeIn')}
          </p>
        </div>
      </div>
    </footer>
  );
}
